<template>
  <div>
    <section class="fullscreen flex-container">
      <Header />
    </section>
    <Content title="Things to do" icon="elephant">
      <p>
        We want everyone to be able to make the most of their time in South
        Africa so we've put together a list of possible activies. This is not a
        definite list there are many more things possible.
      </p>

      <FlexContainer>
        <FlexItem size="50%" padding="large">
          <h2>Glentana</h2>
          <p>
            There's lots to do by the house. People can relax on the beach or go
            for a swim. There is a cafe 5 minutes away where people can go for
            food and drinks.
          </p>
        </FlexItem>
        <FlexItem size="50%" padding="large">
          <h2>Cape Town</h2>
          <p>
            If you make the trip to Cape Town then there are more activities
            available
          </p>
        </FlexItem>
      </FlexContainer>
      <FlexContainer>
        <FlexItem size="50%" padding="large">
          <CopyWithImage
            :key="index"
            v-for="(activity, index) in glentanaActivities"
            :title="activity.name"
            :src="activity.src"
            flexDirection="column"
          ></CopyWithImage>
        </FlexItem>
        <FlexItem size="50%" padding="large">
          <CopyWithImage
            :key="index"
            v-for="(activity, index) in capeTownActivities"
            :title="activity.name"
            :src="activity.src"
            flexDirection="column"
          ></CopyWithImage>
        </FlexItem>
      </FlexContainer>
    </Content>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/ui/Header.vue';
import Content from '@/components/ui/Content.vue';
import ButtonLink from '@/components/ui/ButtonLink.vue';
import CopyWithImage from '@/components/ui/CopyWithImage.vue';
import FlexContainer from '@/components/ui/FlexContainer.vue';
import FlexItem from '@/components/ui/FlexItem.vue';

export default {
  components: {
    Header,
    Content,
    FlexContainer,
    FlexItem,
    ButtonLink,
    CopyWithImage
  },
  computed: {
    ...mapState({
      glentanaActivities: state => state.activities.glentana,
      capeTownActivities: state => state.activities.capeTown
    })
  }
};
</script>

<style lang="scss" scoped>
> section:first-of-type {
  min-height: 10vh;

  @include respond-below(sm) {
    padding: $padding;
  }
}

.section__two {
  background: white;
}
</style>
